import React, { useState, useEffect, useRef } from 'react';
import backgroundImage from './bg.png';
import confetti from 'canvas-confetti';

const StarShooting = () => {
    var defaults = {
        spread: 360,
        ticks: 50,
        gravity: 0,
        decay: 0.94,
        startVelocity: 30,
        colors: ['ffdc00', '52288e', 'ffdc00', '52288e', 'ffdc00']
      };
      
      function shoot() {
        confetti({
          ...defaults,
          particleCount: 40,
          scalar: 1.2,
          shapes: ['star']
        });
      }
      
      setTimeout(shoot, 0);
};

const JokeDisplay = () => {
  const [joke, setJoke] = useState('');
  const [author, setAuthor] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [jokes, setJokes] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const magicRef = useRef(null);

  // Replace these with your actual values
  //const SPREADSHEET_ID = process.env.REACT_APP_JOKEVIEWER_SPREADSHEET_ID;
  //const API_KEY = process.env.REACT_APP_JOKEVIEWER_SHEETS_APIKEY;
  //const SHEET_NAME = process.env.REACT_APP_JOKEVIEWER_SHEETNAME || 'Sheet1';

  // Fetch jokes from Google Sheets
  const fetchJokes = async () => {
    try {
      //const range = `${SHEET_NAME}!A:Z`;  // Fetches all columns
      const url = `/api/jokes.php`;
      
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.values) {
        // Assuming first row is headers: Column A = Joke, Column B = Show in SER
        const headers = data.values[0];
        const jokeIndex = headers.findIndex(h => h.toLowerCase().includes('share your joke'));
        const showIndex = headers.findIndex(h => h.toLowerCase().includes('show in ser'));
        const authorIndex = headers.findIndex(h => h.toLowerCase().includes('author'));
        
        const filteredJokes = data.values
          .slice(1) // Skip header row
          .filter(row => row[showIndex]?.toUpperCase() === 'TRUE')
          .map(row => ({
            text: row[jokeIndex] || '',
            author: row[authorIndex] || 'Anonymous'
          }))
        .filter(jokeObj => jokeObj.text.trim() !== '');        

        if (filteredJokes.length > 0) {
          const randomIndex = Math.floor(Math.random() * filteredJokes.length);
          setJokes(filteredJokes);
          setCurrentIndex(randomIndex);
          setJoke(filteredJokes[randomIndex].text);
          setAuthor(filteredJokes[randomIndex].author);
          setLoading(false);
        } else {
          setError('No jokes found with "Show in SER" set to TRUE');
          setLoading(false);
        }
        StarShooting();
      }
    } catch (err) {
      setError('Failed to fetch jokes. Please check your API key and spreadsheet ID.');
      setLoading(false);
      console.error('Error fetching jokes:', err);
    }
  };

// Animate magic stars
useEffect(() => {
  if (!magicRef.current) return;

  const rand = (min, max) => 
    Math.floor(Math.random() * (max - min + 1)) + min;

  const animate = star => {
    star.style.setProperty("--star-left", `${rand(-10, 100)}%`);
    star.style.setProperty("--star-top", `${rand(-40, 80)}%`);
    star.style.animation = "none";
// eslint-disable-next-line no-unused-expressions
    star.offsetHeight;
    star.style.animation = "";
  };

  const stars = magicRef.current.getElementsByClassName("magic-star");
  let index = 0;
  const interval = 1000;

  for (const star of stars) {
    setTimeout(() => {
      animate(star);
      setInterval(() => animate(star), 1000);
    }, index++ * (interval / 3));
  }
}, [author]);


  // Initial fetch
  useEffect(() => {
    fetchJokes();
  }, []);

  // Re-fetch jokes every X seconds
  const rePollJokes = 60;
  useEffect(() => {
    const refetchInterval = setInterval(() => {
      fetchJokes();
    }, rePollJokes * 1000);

    return () => clearInterval(refetchInterval);
  }, []);

  // Rotate jokes every 15 seconds
  useEffect(() => {
    if (jokes.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = (prevIndex + 1) % jokes.length;
        setJoke(jokes[nextIndex].text);
        setAuthor(jokes[nextIndex].author);
        return nextIndex;
      });
    }, 15000);

    return () => clearInterval(interval);
  }, [jokes]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen w-full p-16">
        <p className="text-2xl text-amber-800 font-light animate-pulse">Loading jokes...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen w-full p-16">
        <p className="text-xl text-red-600 font-light text-center max-w-2xl">{error}</p>
      </div>
    );
  }

  return (
    <div className="jokes flex flex-wrap items-center justify-center min-h-screen w-full p-16">
      <style>{`
  :root {  
    --purple: rgb(82, 40, 142);
    --lightpurple: rgb(214, 203, 228);
    --yellow: rgb(255,220,0);
  }

  @keyframes background-pan {
    from {
      background-position: 0% center;
    }
    to {
      background-position: -200% center;
    }
  }

  @keyframes scale {
    from, to {
      transform: scale(0);
    }
    50% {
      transform: scale(1);
    }
  }

  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(180deg);
    }
  }

  .magic {
    display: inline-block;
    position: relative;
  }

  .magic-star {
    --size: clamp(20px, 1.5vw, 30px);
    animation: scale 1700ms ease forwards;
    display: block;
    height: var(--size);
    left: var(--star-left);
    position: absolute;
    top: var(--star-top);
    width: var(--size);
  }

  .magic-star > svg {
    animation: rotate 5000ms linear infinite;
    display: block;
    opacity: 0.8;
  }

  .magic-star > svg > path {
    fill: white;
  }

  .magic-text {
    animation: background-pan 6s linear infinite;
    background: linear-gradient(
      to right,
      var(--purple),
      var(--lightpurple),
      var(--purple)
    );
    background-size: 200%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    white-space: nowrap;
    font-weight: 800;
  }
  .joke, .author {
        color: var(--purple);
  }
  .punchline {
        color: var(--yellow);
  }
`}</style><p className="joke text-3xl md:text-4xl lg:text-5xl font-montserrat font-bold text-center max-w-4xl leading-relaxed transition-opacity duration-1000 animate-fade-in w-full text-center">
        {joke}
      </p>
      <p className="author text-xl md:text-2xl font-montserrat font-light italic w-full text-center">
  <span className="magic" ref={magicRef}>
    <span className="magic-star">
      <svg width="100%" height="100%" viewBox="0 0 733 733">
        <path clip-rule="evenodd" fill-rule="evenodd" d="M697.077 189.378C725.903 185.612 743.559 219.948 723.738 241.222L579.611 395.915C570.938 405.224 568.817 418.867 574.26 430.34L664.709 620.993C677.149 647.214 649.889 674.663 623.548 662.441L432.02 573.573C420.494 568.225 406.856 570.45 397.607 579.189L243.91 724.395C222.773 744.365 188.269 726.995 191.811 698.167L217.567 488.55C219.117 475.936 212.808 463.668 201.649 457.596L16.2103 356.685C-9.29272 342.807 -3.35761 304.622 25.1722 299.027L232.619 258.346C245.102 255.898 254.842 246.09 257.194 233.599L296.283 26.0263C301.659 -2.52079 339.831 -8.75019 353.921 16.6202L456.374 201.094C462.54 212.196 474.867 218.402 487.481 216.754L697.077 189.378Z"></path>
        </svg>
    </span>
    <span className="magic-star">
      <svg width="100%" height="100%" viewBox="0 0 733 733">
        <path clip-rule="evenodd" fill-rule="evenodd" d="M697.077 189.378C725.903 185.612 743.559 219.948 723.738 241.222L579.611 395.915C570.938 405.224 568.817 418.867 574.26 430.34L664.709 620.993C677.149 647.214 649.889 674.663 623.548 662.441L432.02 573.573C420.494 568.225 406.856 570.45 397.607 579.189L243.91 724.395C222.773 744.365 188.269 726.995 191.811 698.167L217.567 488.55C219.117 475.936 212.808 463.668 201.649 457.596L16.2103 356.685C-9.29272 342.807 -3.35761 304.622 25.1722 299.027L232.619 258.346C245.102 255.898 254.842 246.09 257.194 233.599L296.283 26.0263C301.659 -2.52079 339.831 -8.75019 353.921 16.6202L456.374 201.094C462.54 212.196 474.867 218.402 487.481 216.754L697.077 189.378Z"></path>
        </svg>
    </span>
    <span className="magic-star">
      <svg width="100%" height="100%" viewBox="0 0 733 733">
        <path clip-rule="evenodd" fill-rule="evenodd" d="M697.077 189.378C725.903 185.612 743.559 219.948 723.738 241.222L579.611 395.915C570.938 405.224 568.817 418.867 574.26 430.34L664.709 620.993C677.149 647.214 649.889 674.663 623.548 662.441L432.02 573.573C420.494 568.225 406.856 570.45 397.607 579.189L243.91 724.395C222.773 744.365 188.269 726.995 191.811 698.167L217.567 488.55C219.117 475.936 212.808 463.668 201.649 457.596L16.2103 356.685C-9.29272 342.807 -3.35761 304.622 25.1722 299.027L232.619 258.346C245.102 255.898 254.842 246.09 257.194 233.599L296.283 26.0263C301.659 -2.52079 339.831 -8.75019 353.921 16.6202L456.374 201.094C462.54 212.196 474.867 218.402 487.481 216.754L697.077 189.378Z"></path>
        </svg>
    </span>
    <span className="magic-text">{author}</span>
  </span>
</p>
    </div>

  );
};

export default JokeDisplay